export const useActionParallel = () => {
  /**
   * config bổ sung thêm các cột còn thiêú khi cập nhật hạch toán đồng thời
   */
  const configColumnParalell = [
    { dataField: 'ref_id' },
    { dataField: 'ref_type' },
    { dataField: 'description' },
    { dataField: 'debit_account' },
    { dataField: 'credit_account' },
    { dataField: 'amount_oc' },
    { dataField: 'amount' },
    { dataField: 'budget_source_name' },
    { dataField: 'budget_chapter_code' },
    { dataField: 'budget_sub_kind_item_code' },
    { dataField: 'budget_item_code' },
    { dataField: 'budget_sub_item_code' },
    { dataField: 'method_distribute_name' },
    { dataField: 'cash_withdraw_type_name' },
    { dataField: 'activity_name' },
    { dataField: 'project_code' },
    { dataField: 'bank_account' },
    { dataField: 'budget_source_id' },
    { dataField: 'budget_kind_item_code' },
    { dataField: 'budget_sub_kind_item_code' },
    { dataField: 'cash_withdraw_type_id' },
    { dataField: 'method_distribute_type' },
    { dataField: 'statistic_id' },
    { dataField: 'task_id' },
    { dataField: 'project_id' },
    { dataField: 'activity_id' },
    { dataField: 'accounting_object_id' },
    { dataField: 'fund_id' },
    { dataField: 'fund_structure_id' },
    { dataField: 'topic_id' },
    { dataField: 'budget_fees_id' },
    { dataField: 'contract_id' },
    { dataField: 'budget_detail_item_code' },
    { dataField: 'accounting_object_code' },
    { dataField: 'accounting_object_name' },
    { dataField: 'fund_code' },
    { dataField: 'task_code' },
    { dataField: 'statistic_code' },
    { dataField: 'is_treasury_approved' },
    { dataField: 'sort_order' },
    { dataField: 'fund_structure_name' },
    { dataField: 'budget_provide_code' },
    { dataField: 'topic_code' },
    { dataField: 'budget_fees_code' },
    { dataField: 'contract_no' },
    { dataField: 'is_source_before_year' },
    { dataField: 'quantity' },
    { dataField: 'unitprice' },
    { dataField: 'norm' },
    { dataField: 'inv_no' },
    { dataField: 'inv_date' },
    { dataField: 'sign' },
  ];

  // Mọi người config như bên dưới cho màn hình chứng từ của mình để trường hợp thay đổi dữ liệu tại mỗi màn hình chứng từ thì mảng gốc không bị thay đổi

  //Chuyển khoản kho bạc
  const configColumnParalellBUTransferDetail = [...configColumnParalell];
  //Phiếu thu rút dự toán nhập quỹ
  const configColumnParalellCAReceiptPlanWithdrawDetail = [...configColumnParalell];
  // Phiếu thu rút tiền gửi ngân hàng, kho bạc
  const configColumnParalellCAReceiptWithdrawDetail = [...configColumnParalell];

  //Thu tiền gửi
  const configColumnParalellBADepositDetail = [...configColumnParalell];

  // Mua hàng trả tiền ngay
  const configColumnParalellPUPaymentDetail = [
    { dataField: 'org_ref_detail_id' },
    { dataField: 'ref_id' },
    { dataField: 'ref_type' },
    { dataField: 'description' },
    { dataField: 'debit_account' },
    { dataField: 'credit_account' },
    { dataField: 'amount', mapField: 'inward_amount' },
    { dataField: 'amount_oc', mapField: 'inward_amount' },
    { dataField: 'budget_source_id' },
    { dataField: 'budget_source_name' },
    { dataField: 'budget_chapter_code' },
    { dataField: 'budget_kind_item_code' },
    { dataField: 'budget_sub_kind_item_code' },
    { dataField: 'budget_item_code' },
    { dataField: 'budget_sub_item_code' },
    { dataField: 'budget_detail_item_code' },
    { dataField: 'method_distribute_type' },
    { dataField: 'method_distribute_name' },
    { dataField: 'cash_withdraw_type_id' },
    { dataField: 'cash_withdraw_type_name' },
    { dataField: 'accounting_object_id' },
    { dataField: 'accounting_object_code' },
    { dataField: 'activity_id' },
    { dataField: 'activity_name' },
    { dataField: 'project_id' },
    { dataField: 'project_code' },
    { dataField: 'fund_id' },
    { dataField: 'fund_code' },
    { dataField: 'task_id' },
    { dataField: 'task_code' },
    { dataField: 'statistic_id' },
    { dataField: 'statistic_code' },
    { dataField: 'is_treasury_approved' },
    { dataField: 'sort_order' },
    { dataField: 'fund_structure_id' },
    { dataField: 'fund_structure_name' },
    { dataField: 'bank_account' },
    { dataField: 'budget_provide_code' },
    { dataField: 'topic_id' },
    { dataField: 'topic_code' },
    { dataField: 'budget_fees_id' },
    { dataField: 'budget_fees_code' },
    { dataField: 'contract_id' },
    { dataField: 'contract_no' },
    { dataField: 'is_source_before_year' },
    { dataField: 'quantity' },
    { dataField: 'unitprice' },
    { dataField: 'norm' },
    { dataField: 'inv_no' },
    { dataField: 'inv_date' },
    { dataField: 'task_code' },
    { dataField: 'statistic_id' },
    { dataField: 'statistic_code' },
    { dataField: 'expiry_date' },
    { dataField: 'lot_no' },
    { dataField: 'is_treasury_approved' },
    { dataField: 'sort_order' },
    { dataField: 'org_ref_no' },
    { dataField: 'org_ref_date' },
    { dataField: 'fund_structure_id' },
    { dataField: 'fund_structure_name' },
    { dataField: 'budget_provide_code' },
    { dataField: 'topic_id' },
    { dataField: 'topic_code' },
    { dataField: 'contract_id' },
    { dataField: 'contract_no' },
    { dataField: 'is_source_before_year' },
    { dataField: 'norm' },
  ];

  const configColumnFixedAssetParalell = [
    { dataField: 'ref_id' },
    { dataField: 'ref_type' },
    { dataField: 'description' },
    { dataField: 'debit_account' },
    { dataField: 'credit_account' },
    { dataField: 'amount_oc', mapField: 'amount' },
    { dataField: 'amount' },
    { dataField: 'budget_source_name' },
    { dataField: 'budget_chapter_code' },
    { dataField: 'budget_sub_kind_item_code' },
    { dataField: 'budget_item_code' },
    { dataField: 'budget_sub_item_code' },
    { dataField: 'method_distribute_name' },
    { dataField: 'cash_withdraw_type_name' },
    { dataField: 'activity_name' },
    { dataField: 'project_code' },
    { dataField: 'bank_account' },
    { dataField: 'budget_source_id' },
    { dataField: 'budget_kind_item_code' },
    { dataField: 'budget_sub_kind_item_code' },
    { dataField: 'cash_withdraw_type_id' },
    { dataField: 'method_distribute_type' },
    { dataField: 'statistic_id' },
    { dataField: 'task_id' },
    { dataField: 'project_id' },
    { dataField: 'activity_id' },
    { dataField: 'accounting_object_id' },
    { dataField: 'fund_id' },
    { dataField: 'fund_structure_id' },
    { dataField: 'topic_id' },
    { dataField: 'budget_fees_id' },
    { dataField: 'contract_id' },
    { dataField: 'budget_detail_item_code' },
    { dataField: 'accounting_object_code' },
    { dataField: 'fund_code' },
    { dataField: 'task_code' },
    { dataField: 'statistic_code' },
    { dataField: 'is_treasury_approved' },
    { dataField: 'sort_order' },
    { dataField: 'fund_structure_name' },
    { dataField: 'budget_provide_code' },
    { dataField: 'topic_code' },
    { dataField: 'budget_fees_code' },
    { dataField: 'contract_no' },
    { dataField: 'is_source_before_year' },
    { dataField: 'quantity' },
    { dataField: 'unitprice' },
    { dataField: 'norm' },
    { dataField: 'inv_no' },
    { dataField: 'inv_date' },
    { dataField: 'sign' },
  ];

  return {
    configColumnParalell,
    configColumnParalellBUTransferDetail,
    configColumnParalellCAReceiptPlanWithdrawDetail,
    configColumnParalellCAReceiptWithdrawDetail,
    configColumnParalellBADepositDetail,
    configColumnParalellPUPaymentDetail,
    configColumnFixedAssetParalell,
  };
};
